import constants from '~/constants'

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/tests/')) {
    return navigateTo(constants.testsUrl, { external: true, redirectCode: 301 })
  }
})
